/**
 * Product Variant Selector V2
 * Управление выбором вариантов (вес) и обновлением цены
 */

(function () {
if (window.ProductVariantSelectorV2) {
  if (typeof window.initProductVariantSelectorV2 === 'function') {
    window.initProductVariantSelectorV2();
  }
  return;
}

class ProductVariantSelectorV2 {
  constructor() {
    this.variantSelects = document.querySelector('variant-selects');
    if (!this.variantSelects) return;

    this.productForm = document.querySelector(`#${this.variantSelects.dataset.section}`);
    this.productInfo = document.querySelector(`product-info[data-section="${this.variantSelects.dataset.section}"]`);
    
    this.weightItems = document.querySelectorAll('.product-text-weight-item');
    this.priceElement = document.querySelector('.product-text-price-main');
    this.comparePriceElement = document.querySelector('.product-text-price-sale');
    this.unitPriceElement = document.querySelector(`#unit-price-${this.variantSelects.dataset.section}`);
    this.addToCartButton = document.querySelector('.product-text-buy-btn');
    this.addToCartButtonPrice = document.querySelector('.product-text-buy-btn-price');
    this.variantInput = document.querySelector('input[name="id"]');
    
    this.init();
  }

  init() {
    if (this.weightItems.length === 0) return;

    // Загружаем данные о вариантах
    this.loadVariantData();

    // Добавляем обработчики кликов на варианты веса
    this.weightItems.forEach(item => {
      item.addEventListener('click', (e) => this.handleVariantChange(e.currentTarget));
    });
  }

  loadVariantData() {
    // Получаем JSON с вариантами из скрипта на странице
    const variantScript = document.querySelector('script[data-selected-variant]');
    if (variantScript) {
      try {
        this.currentVariant = JSON.parse(variantScript.textContent);
      } catch (e) {
        console.error('Error parsing variant data:', e);
      }
    }

    // Получаем все варианты продукта
    if (typeof window.productVariants !== 'undefined') {
      this.variants = window.productVariants;
    } else {
      // Если глобальные варианты не определены, пытаемся получить их из product-info
      this.fetchVariants();
    }
  }

  async fetchVariants() {
    const productUrl = this.variantSelects.dataset.url;
    if (!productUrl) return;

    try {
      const response = await fetch(`${productUrl}.js`);
      const productData = await response.json();
      this.variants = productData.variants;
    } catch (error) {
      console.error('Error fetching product variants:', error);
    }
  }

  handleVariantChange(selectedItem) {
    // Убираем активный класс со всех вариантов
    this.weightItems.forEach(item => item.classList.remove('active'));
    
    // Добавляем активный класс к выбранному
    selectedItem.classList.add('active');

    // Получаем выбранное значение
    const optionIndex = selectedItem.dataset.variantOption;
    const optionValue = selectedItem.dataset.variantValue;

    // Находим соответствующий вариант
    const selectedVariant = this.findVariantByOption(optionValue);
    
    if (selectedVariant) {
      this.updateProduct(selectedVariant);
    }
  }

  findVariantByOption(optionValue) {
    if (!this.variants) return null;

    // Ищем вариант по значению опции
    return this.variants.find(variant => {
      return variant.option1 === optionValue || 
             variant.option2 === optionValue || 
             variant.option3 === optionValue;
    });
  }

  updateProduct(variant) {
    if (!variant) return;

    // Обновляем основную цену
    if (this.priceElement) {
      const formattedPrice = this.formatMoney(variant.price);
      this.priceElement.textContent = formattedPrice;
      this.priceElement.dataset.price = variant.price;
    }

    // Обновляем цену со скидкой
    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      if (this.comparePriceElement) {
        this.comparePriceElement.textContent = this.formatMoney(variant.compare_at_price);
        this.comparePriceElement.style.display = '';
      }
      // Показываем лейбл скидки
      const saleLabel = document.querySelector('.product-label--blackweek');
      if (saleLabel) {
        saleLabel.style.display = '';
      }
    } else {
      if (this.comparePriceElement) {
        this.comparePriceElement.style.display = 'none';
      }
      // Скрываем лейбл скидки
      const saleLabel = document.querySelector('.product-label--blackweek');
      if (saleLabel) {
        saleLabel.style.display = 'none';
      }
    }

    // Обновляем цену за единицу (за кг)
    if (this.unitPriceElement && variant.unit_price) {
      const unitPrice = this.formatMoney(variant.unit_price);
      const unitMeasurement = variant.unit_price_measurement?.reference_unit || 'kg';
      this.unitPriceElement.textContent = `${unitPrice}/${unitMeasurement}`;
      this.unitPriceElement.style.display = '';
    } else if (this.unitPriceElement) {
      this.unitPriceElement.style.display = 'none';
    }

    // Обновляем кнопку "В корзину"
    if (this.addToCartButton) {
      const buttonText = this.addToCartButton.querySelector('.t2');

      if (variant.available) {
        this.addToCartButton.disabled = false;
        if (buttonText) {
          buttonText.textContent = this.getTranslation('addToCart');
        }
        this.addToCartButton.dataset.price = variant.price;
      } else {
        this.addToCartButton.disabled = true;
        if (buttonText) {
          buttonText.textContent = this.getTranslation('soldOut');
        }
      }
    }

    // Обновляем цену в кнопке
    if (this.addToCartButtonPrice) {
      this.addToCartButtonPrice.textContent = this.formatMoney(variant.price);
    }

    // Обновляем скрытое поле с ID варианта
    if (this.variantInput) {
      this.variantInput.value = variant.id;
      this.variantInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    // Обновляем изображение если у варианта есть свое изображение
    if (variant.featured_media) {
      this.updateMainImage(variant.featured_media);
    }

    // Обновляем URL
    this.updateURL(variant.id);

    // Отправляем событие об изменении варианта
    this.dispatchVariantChangeEvent(variant);
  }

  updateMainImage(media) {
    const mainImage = document.querySelector('#MainProductImage-' + this.variantSelects.dataset.section);
    if (!mainImage || !media) return;

    const newImageUrl = media.src || media.preview_image?.src;
    if (newImageUrl) {
      mainImage.src = newImageUrl;
    }

    // Обновляем активную миниатюру
    const thumbnails = document.querySelectorAll('.product-image-tumb-img');
    thumbnails.forEach((thumb, index) => {
      const thumbImg = thumb.querySelector('img');
      if (thumbImg && thumbImg.src.includes(media.id)) {
        thumbnails.forEach(t => t.classList.remove('active'));
        thumb.classList.add('active');
      }
    });
  }

  updateURL(variantId) {
    if (!variantId) return;
    
    const url = new URL(window.location.href);
    url.searchParams.set('variant', variantId);
    window.history.replaceState({}, '', url.toString());
  }

  dispatchVariantChangeEvent(variant) {
    document.dispatchEvent(new CustomEvent('variant:change', {
      detail: { variant },
      bubbles: true
    }));
  }

  formatMoney(cents) {
    // Используем Shopify.formatMoney если доступен
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      return Shopify.formatMoney(cents, window.theme?.moneyFormat || '{{amount}}');
    }
    
    // Fallback форматирование
    const amount = (cents / 100).toFixed(2);
    return `€${amount}`;
  }

  getTranslation(key) {
    // Используем глобальные переводы если доступны
    if (typeof window.variantStrings !== 'undefined') {
      return window.variantStrings[key] || key;
    }
    
    // Fallback переводы (camelCase ключи как в window.variantStrings)
    const translations = {
      addToCart: 'В корзину',
      soldOut: 'Распродано'
    };
    
    return translations[key] || key;
  }
}

window.ProductVariantSelectorV2 = ProductVariantSelectorV2;

function initProductVariantSelectorV2() {
  window.__frostixProductVariantSelectorInstance = new ProductVariantSelectorV2();
  return window.__frostixProductVariantSelectorInstance;
}

window.initProductVariantSelectorV2 = initProductVariantSelectorV2;

// Инициализация при загрузке DOM
document.addEventListener('DOMContentLoaded', () => {
  initProductVariantSelectorV2();
});

// Экспорт для использования в других скриптах
if (typeof module !== 'undefined' && module.exports) {
  module.exports = ProductVariantSelectorV2;
}
})();
